import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-api-game-management',
  templateUrl: './api-game-management.component.html',
  styleUrls: ['./api-game-management.component.scss']
})
export class ApiGameManagementComponent implements OnInit {
  public company_uuid: string;
  public games: any[] = [];
  public categories: any[] = [];
  public selected_category = '';
  public is_loading = false;

  constructor(private http: HttpService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  async ngOnInit() {
    await Promise.all([this.loadCategories(), this.loadGames()]);
  }

  async loadCategories() {
    this.categories = await this.http.post('/admin/app/game/category/init') as any[];
  }

  async loadGames() {
    this.is_loading = true;
    const data: any = {};
    if (this.selected_category) {
      data.category_id = this.selected_category;
    }
    this.games = await this.http.post('/admin/setting/seemless-game/get/list', data) as any[];
    this.is_loading = false;
  }

  async onCategoryChange() {
    await this.loadGames();
  }

  async saveSort(game: any) {
    await this.http.post('/admin/setting/seemless-game/sort/update', { uuid: game.uuid, sort: game.sort });
  }

  async moveUp(index: number) {
    if (index === 0) return;
    const a = this.games[index];
    const b = this.games[index - 1];
    const tmpSort = a.sort;
    a.sort = b.sort;
    b.sort = tmpSort;
    this.games[index] = b;
    this.games[index - 1] = a;
    await Promise.all([
      this.http.post('/admin/setting/seemless-game/sort/update', { uuid: a.uuid, sort: a.sort }),
      this.http.post('/admin/setting/seemless-game/sort/update', { uuid: b.uuid, sort: b.sort })
    ]);
  }

  async moveDown(index: number) {
    if (index === this.games.length - 1) return;
    const a = this.games[index];
    const b = this.games[index + 1];
    const tmpSort = a.sort;
    a.sort = b.sort;
    b.sort = tmpSort;
    this.games[index] = b;
    this.games[index + 1] = a;
    await Promise.all([
      this.http.post('/admin/setting/seemless-game/sort/update', { uuid: a.uuid, sort: a.sort }),
      this.http.post('/admin/setting/seemless-game/sort/update', { uuid: b.uuid, sort: b.sort })
    ]);
  }

  async deleteGame(game: any) {
    const confirmed = window.confirm(`You are about to remove "${game.title}" from the record. This is not reversible. Are you sure?`);
    if (confirmed) {
      await this.http.post('/admin/setting/remove/update', { title: game.title, table: 'setting_seemless_game', uuid: game.uuid });
      await this.loadGames();
    }
  }
}
